import { render, staticRenderFns } from "./MarketLink.vue?vue&type=template&id=3f5b8136&scoped=true"
import script from "./MarketLink.vue?vue&type=script&lang=js"
export * from "./MarketLink.vue?vue&type=script&lang=js"
import style0 from "./MarketLink.vue?vue&type=style&index=0&id=3f5b8136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5b8136",
  null
  
)

export default component.exports